import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'webCollaborationPermissionRequestsDialog.title',
    defaultMessage:
      'Richiesta permessi',
  },
  content: {
    id: 'webCollaborationPermissionRequestsDialog.content',
    defaultMessage: 'Il processo non può andare avanti se non si concedono i permessi al microfono e alla webcam.',
  },
  continuedButton: {
    id: 'webCollaborationPermissionRequestsDialog.continueButton',
    defaultMessage: 'ABILITA',
    description: 'Label for the "continued" button',
  },
  contentLine2: {
    id: 'webCollaborationPermissionRequestsDialog.contentLine2',
    defaultMessage: 'Vai nelle impostazioni del browser (o clicca sul simbolo del video nella barra in alto), abilita la camera ed il microfono per questo sito e poi clicca su PROCEDI per proseguire.',
  },
  enabledButton: {
    id: 'webCollaborationPermissionRequestsDialog.enabledButton',
    defaultMessage: 'PROCEDI',
    description: 'Label for the "continued" button',
  },
});
